// app.component.ts
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { IdleService } from './services/idel.service';
import { MessageManagerService } from './services/messagemanagerService.service';
import { NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { CommonPopupComponent } from './shared/shared-components';
import { CommonPopupService } from './services/common-popup.service';
import { PrimeNgI18nService } from './services/prime-ng-i18n.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports:[
      NgOtpInputModule,
      RouterModule,
      ToastModule,
      NgxUiLoaderModule,
      CommonPopupComponent
    ]
})
export class AppComponent implements OnInit, OnDestroy {
  /** PrimeNG locale (DatePicker, filters, aria, …); constructed for side effects only. */
  private readonly primeNgI18n = inject(PrimeNgI18nService);

  private idleSubscription!: Subscription;

  // Common popup properties
  showCommonPopup: boolean = false;
  popupTitle: string = 'Information';
  popupMessage: string = '';

  constructor(
    private idleService: IdleService,
    private authService: AuthService,
      private messageService: MessageManagerService,
      private router: Router,
      private commonPopupService: CommonPopupService
  ) {
      this.router.events.subscribe(event => {
          if (event instanceof NavigationStart) {
              if (event.navigationTrigger === 'popstate') {
                  this.router.navigate(['/app/dashboard']); // Redirect to the dashboard page on back button
              }
          }
      });
  }

    ngOnInit(): void {
    this.idleService.startWatching();
    this.idleSubscription = this.idleService.onTimeout().subscribe(() => {
      this.authService.logout('session_expired');
    });

    // Subscribe to common popup notifications from interceptor
    this.commonPopupService.popup$.subscribe(notification => {
      this.showCommonPopupDialog(notification.title, notification.message);
    });
  }

  ngOnDestroy(): void {
    this.idleService.stopWatching();
    if (this.idleSubscription) {
      this.idleSubscription.unsubscribe();
    }
  }

  // Method to show common popup
  showCommonPopupDialog(title: string, message: string) {
    this.popupTitle = title;
    this.popupMessage = message;
    this.showCommonPopup = true;
  }

  // Method to close common popup
  closeCommonPopup() {
    this.showCommonPopup = false;
    this.popupTitle = '';
    this.popupMessage = '';
  }
}
